import React, { useMemo } from "react";
import { useParams } from 'react-router-dom';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import useFetchRptDetailByRptId from "../../Hooks/Mfg/useFetchRptDetailByRptId";
import Download2Pdf from "../../common/Download2Pdf";
import Spinner from "../../common/Spinner";
import { getCurrentDateTime } from "../../../utils/basic";
// import { useDownloadAsCsv } from "../../Hooks/common/useDownloadAsCsv";
// import { useMfgViewReportPlates } from "../../../store/reportStore";
import { CSVLink } from "react-csv";

const MfgRptDetails = () => {
    const { rptuid, serialnum } = useParams();
    const rptData = useFetchRptDetailByRptId(rptuid);
    // Stored the data in a store - if needed to bring it here 
    // const mfgReportPlates = useMfgViewReportPlates();
    //  const plates = [];
    const parseNestedData = (data, prefix = '', mainKey = '') => {
        let rows = [];
        for (const [key, value] of Object.entries(data)) {
            // If we have a mainKey and prefix is empty, it means we're at the start of a new mainKey section
            if (mainKey && prefix === '') {
                rows.push({
                    //   id: rows.length,
                    mainKey,
                });
            }
            if (['Total_wells', 'Plate', 'Serial Number'].includes(key)) {
                rows.push({
                    //  id: rows.length,
                    Statistic: `${prefix}${key.replace(/_/g, key === 'Total_wells' ? ' ' : '')}`,
                    Specification: '',
                    ObservedValue: value,
                    //passfailValue: true,
                    singleKey: true,
                });
            } else if (typeof value === 'object' && !Array.isArray(value)) {
                if (value.Threshold && value.Value !== undefined) {
                    rows.push({
                        //   id: rows.length,
                        Statistic: `${prefix}${key.replace(/_/g, ' ')}`,
                        Specification: value.Threshold,
                        ObservedValue: (typeof value.Value === 'number' ? value.Value.toFixed(4) : value.Value) ?? '',
                        passfailValue: value?.pass === true ? 'Pass' : value?.pass === false ? 'Fail' : '',
                    });
                } else {
                    // we call the function recursively if we encounter an object
                    rows = rows.concat(parseNestedData(value, `${prefix}${key.replace(/_/g, ' ')}.`, key));
                }
            }
        }

        return rows;
    }


    const dataForTable = () => {
        if (!rptData?.isLoading && !rptData?.isError) {
            let rows = [];

            Object.entries(rptData?.data).forEach(([key, value]) => {
                rows.push({
                    // id: rows.length,
                    Statistic: '',
                    Specification: key === 'Header' ? '' : key.toUpperCase(),// Add the main key row
                    ObservedValue: '',
                    // passfailValue: true,
                    mainRowKey: true, // Add a flag to identify the main key rows
                    channel: key.toUpperCase(),
                });
                // plates?.push({
                //     "Plate Name": key,
                //     "Plate Value": value?.Plate
                // });
                const dataToMassage = rptData?.data[key];
                // console.log('dataToMassage', dataToMassage);
                rows = rows.concat(parseNestedData(dataToMassage, ''));

            });

            return rows;
        }
    }

    const data = useMemo(() => {
        // Reroder the data to make Plate as the first row in the reports table
        const dataToReorder = dataForTable(rptData);
        if (!dataToReorder?.length) return [];

        const reorderedData = [];
        let skipFirst = true; // skip the HEADER record row from the reports table

        for (let i = 0; i < dataToReorder.length; i++) {
            const item = dataToReorder[i];

            if (item?.mainRowKey && !skipFirst) {
                reorderedData.push(item);

                // // Find the next "Plate" item
                // let plateIndex = null;
                // for (let j = i + 1; j < dataToReorder.length; j++) {
                //     if (dataToReorder[j].Statistic === "Plate") {
                //         plateIndex = j;
                //         break;
                //     }
                // }

                // if (plateIndex !== null) {
                //     reorderedData.push(dataToReorder.splice(plateIndex, 1)[0]); // Remove and insert "Plate"
                // }
                // Find and insert "Plate" item
                for (let j = i + 1; j < dataToReorder.length; j++) {
                    if (dataToReorder[j].Statistic === "Plate") {
                        reorderedData.push(dataToReorder.splice(j, 1)[0]);// Remove and insert "Plate"
                        break;
                    }
                }

                // Find and insert "Total_wells" item (if it exists) - new ask from 925
                for (let j = i + 1; j < dataToReorder.length; j++) {
                    if (dataToReorder[j].Statistic === "Total wells") {
                        reorderedData.push(dataToReorder.splice(j, 1)[0]);//Remove and insert Total_wells
                        break;
                    }
                }
            } else {
                reorderedData.push(item);
                skipFirst = false;
            }
        }
        return reorderedData;


    }, [rptData]);

    const formattedDateTime = getCurrentDateTime();
    // Prepare CSV headers
    const headers = [
        {
            label: `Date: ${formattedDateTime}`, // Insert date into the label
            key: "date" // Optional key for sorting, if needed 
        },
        { label: "Statistic", key: "Statistic" },
        { label: "Specification", key: "Specification" },
        { label: "Observed Value", key: "ObservedValue" },
        { label: "Pass/Fail", key: "passfailValue" }
    ];


    const csvReport = {
        filename: serialnum ? `${serialnum}-${rptuid}.csv` : `${rptuid}.csv`,
        headers: headers,
        data: data
    };
    // the email id solution is a temp one - will be doing a generalized comp for slack feedback later 
    return (
        <>

            <div>
                {rptData?.isLoading ? (
                    <Spinner text="Fetching Data... Pls wait" />
                ) : rptData?.isError ? (
                    <div className="flex px-16 py-16 justify-center items-center" >
                        <p className="text-red-600 font-bold">Error Occured while fetching Data. Please contact the  Application Team at <span className="text-blue-500">one_tool_support@bio-rad.com</span></p>
                    </div>
                ) : (
                    <>
                        { /*  comment the below out for future use if 925 comes back*/}
                        {/* {plates?.map((item, i) => (
                            <h1 className="px-5 py-3  text-left text-xs font-bold
                                             text-custom-green  uppercase tracking-wider" key={i}>{item["Plate Name"]} - {item["Plate Value"]}</h1>
                        ))} */}
                        {/* <div className="flex items-start pb-10">
                            <table className="border-collapse w-full table-auto text-md">
                                <thead className="sticky top-0">
                                    <tr>
                                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold
                                             text-custom-green  uppercase tracking-wider">Plate Name</th>
                                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold
                                             text-custom-green  uppercase tracking-wider">Plate Value</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {plates?.map((row, i) => (
                                        <tr key={i}>
                                            <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs 
                                            font-semibold leading-snug text-gray-600 uppercase tracking-wider">{row["Plate Name"]}</td>
                                            <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold leading-snug text-gray-600 uppercase tracking-wider">{row["Plate Value"]}</td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div> */}

                        <div className="flex items-end p-5">
                            <div className="flex-grow"></div>
                            <Download2Pdf reportData={data} reportType="fixedCol" />
                            <span className="p-2"> </span>
                            <CSVLink
                                {...csvReport}// this will be the file name
                                className="text-center p-1 border border-custom-green rounded-[8px]
                                              bg-custom-green text-xs 
                                            font-semibold leading-snug text-white uppercase tracking-wider"
                            >
                                <CloudDownloadIcon fontSize="small" /> CSV
                            </CSVLink>
                        </div>


                        <div className="flex flex-col border-2 border-solid h-[70vh] overflow-auto">
                            <span className="p-5 text-xs font-bold text-custom-green uppercase tracking-w">Date: {formattedDateTime}</span>

                            <table className="border-collapse table-auto w-full text-md">
                                <thead className="sticky top-0">
                                    <tr>
                                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold
                                             text-custom-green  uppercase tracking-wider">Statistic</th>
                                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold
                                             text-custom-green  uppercase tracking-wider">Specification</th>
                                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold
                                             text-custom-green  uppercase tracking-wider">Observed Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((row, i) => (
                                        <tr key={i} className={row?.mainRowKey ? 'mainRow' : ''}>
                                            {/* <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs 
                                            font-semibold leading-snug text-gray-600 uppercase tracking-wider">{row?.Statistic}</td> */}
                                            <td className={`px-5 py-3 border-b-2 border-gray-200 bg-gray-100 
                                            text-left text-xs leading-snug uppercase tracking-wider ${row?.Statistic === "Plate" ? "font-[900] underline text-custom-green" : "font-semibold text-gray-600 "}`}
                                            >
                                                {row?.Statistic}
                                            </td>
                                            <td className={row?.mainRowKey ? "border-b-2 border-gray-200 bg-gray-100 leading-snug font-bold text-custom-green uppercase tracking-wider" :
                                                "px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold leading-snug text-gray-600 uppercase tracking-wider"}>{row?.Specification}</td>
                                            <td className={row?.mainRowKey || row?.singleKey ? "border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold leading-snug" : (row?.passfailValue === 'Pass' ? 'pass px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold leading-snug' : row?.passfailValue === 'Fail' ? 'fail px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold leading-snug' : '')}>{row.ObservedValue}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )
                }
            </div>

        </>

    )

}

export default MfgRptDetails;


